import TemplatesPage from 'components/Templates'

export default TemplatesPage
